export default __webpack_public_path__ + "static/media/icon_triangle_down.ff7bf7a7.svg";